import styled, { css } from 'styled-components'

import { Link } from '@ui/links/Link'

export const Wrapper = styled.footer`
  display: flex;
  flex-direction: column;
  padding-bottom: ${({ theme }) => theme.fontSizes[3]}px;
  position: relative;
`

export const CopyrightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: ${({ theme }) => theme.fontSizes[2]}px;
  width: 100%;

  ${({ theme }) => theme.below.mobileL`
    flex-direction: column;
  `}

  ${({ theme }) => theme.below.tablet`
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-wrap: nowrap;
  `}
`

export const ListText = styled.p`
  color: ${({ theme }) => theme.colors.silver};
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  font-weight: 300;
  line-height: 1.5;
  padding: 5px 0px;
  ${({ theme }) => theme.below.mobileXL`
    padding: 4px 0px;
  `}
  white-space: pre-line;
`

export const Copyright = styled.p`
  color: ${props => props.theme.colors.silver};
  font-size: ${props => props.theme.fontSizes[0]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};

  &:after {
    content: '|';
    margin: 0 ${({ theme }) => theme.spaces[2]}px;

    ${({ theme }) => theme.below.mobileL`
      content: none;
    `}
  }
`

export const Privacy = styled(Link)`
  color: ${props => props.theme.colors.silver};
  font-size: ${props => props.theme.fontSizes[0]}px;
  font-weight: ${({ theme }) => theme.fontWeight[2]};
`

export const SocialList = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin-top: 1px;

    ${theme.below.laptopL`
     margin-top: ${theme.newSpaces.xs}px;
    `}

    ${theme.below.mobileXL`
      margin-top: ${theme.newSpaces.lg}px;
      justify-content: center;
    `}
  `}
`

export const SocListAndTextWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 20px;
    justify-content: space-between;

    ${theme.below.mobileXL`
      justify-content: center;
    `}
  `}
`

export const SocialListItem = styled.div`
  box-shadow: none;

  :not(:first-child) {
    margin-left: ${props => props.theme.spaces[3]}px;
  }
`

export const Title = styled.p`
  color: ${({ theme }) => theme.newColors.primary};
  font-size: ${({ theme }) => theme.fontSizes[4]}px;
  font-weight: ${({ theme }) => theme.fontWeight[8]};
  line-height: 28px;
  margin-bottom: ${({ theme }) => theme.spaces[3]}px;

  ${({ theme }) => theme.below.mobileXL`
    margin: ${({ theme }) => theme.spaces[3]}px auto;
  `}
`

export const FooterLink = styled(Link)`
  color: ${({ theme }) => theme.colors.silver};
  font-size: ${({ theme }) => theme.fontSizes[14]}px;
  font-weight: 300;
  line-height: 1.3;
  padding: 4px 0px;
  text-decoration: none;
  white-space: pre-line;
  width: fit-content;

  img {
    object-fit: contain;
  }

  &:hover {
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 2px;
  }

  ${({ theme }) => theme.below.mobileXL`
    margin: 0 auto;
  `}
`

export const OrangeLink = styled(Link)`
  font-size: inherit;

  &:hover {
    text-decoration: underline;
  }
`

export const BlocksGroupWrapper = styled.div`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 30px;
  position: relative;
  width: 100%;

  ${({ theme }) => theme.below.tablet`
    justify-content: center;
    gap: 0;
  `}
`

export const BlockWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.spaces[3]}px;
  width: 200px;

  ${({ theme }) => theme.below.laptop`
    padding: ${theme.newSpaces.xs}px;
    justify-content: center;
    width: 240px;
  `}

  ${({ theme }) => theme.below.mobileXL`
    text-align: center;
    margin: 0 auto;
    width: 100%;
  `}
`

export const ContactUsBlock = styled(BlockWrapper)`
  ${({ theme }) => css`
    width: 100%;

    ${theme.below.laptopL`
      width: 200px;
    `}

    ${theme.below.laptop`
      width: 240px;
    `}

    ${theme.below.mobileM`
      min-width: unset;
    `}
  `}
`

export const LogoWrapper = styled.div`
  bottom: 0;
  cursor: pointer;
  position: absolute;
  right: -28px;
  width: 151px;

  ${({ theme }) => theme.above.desktopS`
    bottom: 0px;
  `}

  ${({ theme }) => theme.below.laptop`
    right: 0;
  `}

  ${({ theme }) => theme.below.tablet`
    position: static;
  `}

  ${({ theme }) => theme.below.mobileXL`
    margin: 9px 0 35px;
  `}
`
